import React, {useRef, useEffect} from 'react'
import Slider from "@arcgis/core/widgets/Slider";
import SliderVM from './SliderVM';

const SliderWidget = (props:any)=>{
    const sliderDiv = useRef(null);
    const {layer,view}=props
    let slider
    useEffect(()=>{
      if (sliderDiv.current) {
        SliderVM(view,sliderDiv.current,layer)
        .then(widget=>{
          slider=widget
        })
        
       return () => {
        slider.destroy();
      };
    }
  }, []);
      
  return (
    <div ref={sliderDiv}></div>
  )
}

export default SliderWidget
